import React, { useEffect, useState } from "react";
import FormCreateLibrary from "../../../components/Forms/FormCreateLibrary/FormCreateLibrary";
import {
  Category,
  answerType,
  answerTypeIcon,
} from "../../../models/SurveyModels";
import { getI18n, useTranslation } from "react-i18next";
import { IOption } from "../../../components/Forms/FormInput/FormSelect/FormSelect";
import { useNavigate, useParams } from "react-router-dom";
import { useEndpoints } from "../../../hooks/useEndpoints";
import { useToastAlert } from "../../../components/ToastAlert/ToastAlert";
import { IErrorsCompanies } from "../../../models/CompaniesModel";
import { RoutesRouter } from "../../../models/Routes";
import { DURATION_TOAST } from "../../../utils/costants";
import { ResourcePayload } from "../../../models/LibraryModels";

const CreateLibrary = () => {
  const { t } = useTranslation();

  const [library, setLibrary] = useState<ResourcePayload>();
  const [categories, setCategories] = useState<IOption[]>([]);
  const [helpCategories, setHelpCategories] = useState<IOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [answer, setAnswer] = useState<IOption[]>([]);
  const navigate = useNavigate();
  const { getLibrarybyId, getCategories, putLibrary, createLibrary } =
    useEndpoints();
  const { id } = useParams();
  const { showToast } = useToastAlert();

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      getLibrarybyId(id).then((resp) => {
        setLibrary(resp);
        setIsLoading(false);
      });
    }
    const language = getI18n().language.includes("it") ? "ITALIAN" : "ENGLISH";
    const toOptions = (resp: Category[]): IOption[] =>
      resp.map((category: Category) => {
        return {
          [category.name]: category.id,
          [category.icon]: "icon",
          [category.color]: "color",
          [category.background]: "background",
        };
      });
    getCategories({ language }).then((resp) => setCategories(toOptions(resp)));
    getCategories({ language, type: "HELP" }).then((resp) =>
      setHelpCategories(toOptions(resp))
    );
    const answerWhitIcon = answerType.map((item, index) => {
      return { ...item, ...answerTypeIcon[index] };
    });
    setAnswer(answerWhitIcon);
  }, [getCategories, getLibrarybyId, id, t]);

  const onSubmit = async (data: ResourcePayload) => {
    if (id) {
      const response = await putLibrary(id, data);
      if (response.status === 200) {
        navigate(RoutesRouter.library);
        showToast({
          message: `${t("library.toast.success.edit")}`,
          type: "success",
          duration: DURATION_TOAST,
        });
      }
      if (response.status === 400) {
        const { errors } = await response.json();
        errors.map(({ value, msg, param }: IErrorsCompanies) =>
          showToast({
            message: `${msg} ${param}`,
            subMessage: value,
            type: "error",
          })
        );
      }
      if (response.status === 500) {
        showToast({
          message: `${t("home.questions.toast.error.generic")}`,
          type: "error",
        });
      }
    } else {
      const response = await createLibrary(data);
      if (response.status === 201) {
        navigate(RoutesRouter.library);
        showToast({
          message: `${t("library.toast.success.create")}`,
          type: "success",
          duration: DURATION_TOAST,
        });
      }
      if (response.status === 400) {
        const { errors } = await response.json();
        errors?.map(({ value, msg, param }: IErrorsCompanies) =>
          showToast({
            message: `${msg} ${param}`,
            subMessage: value,
            type: "error",
          })
        );
      }
      if (response.status === 500) {
        showToast({
          message: `${t("home.questions.toast.error.generic")}`,
          type: "error",
        });
      }
    }
  };

  return (
    <div className="container-custom custom-form-container">
      <div className="container__home">
        <FormCreateLibrary
          isLoading={isLoading}
          onSumbitForm={onSubmit}
          answerType={answer}
          libraryData={library}
          categories={categories}
          helpCategories={helpCategories}
        />
      </div>
    </div>
  );
};

export default CreateLibrary;
